import { UserState } from "../../domain/Account/userSlice"
import { RootState } from "../../reduxStore/store"
import { HEALTH_ADVOCATE_DIRECTORY_ISSUER } from "../authentication/msalClient/msal"

export const selectValidatedHealthAdvocateUser = (
  state: RootState,
): boolean => {
  //compare issuer value on ID token from HA AAD with expected value
  return (
    state.authentication.accountInfo?.idTokenClaims?.idp ===
    HEALTH_ADVOCATE_DIRECTORY_ISSUER
  )
}
export const selectUser = (state: { user: UserState }) => state.user
